import routes from '@/modules/user/routes'
import store from '@/modules/user/store'

export default { routes, store }
